export default __webpack_public_path__ + "static/media/home2XL.815bfb5d.webp";